<div class="sale-member-request-popup">
  <form
    name="saleMemberRequestForm"
    (ngSubmit)="formSubmit()"
    [formGroup]="form"
    novalidate
  >
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Request Sale Access</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row mb-2" *ngIf="!isDenied">
        <div class="col-2 align-self-center">
          <mat-label>Access</mat-label>
        </div>
        <div class="col-10 align-self-center">
          <mat-checkbox
            class="me-1"
            formControlName="isViewAccess"
            [disabled]="!data.isViewRequestAllowed"
          >
            <mat-label class="me-2" *ngIf="data.isViewRequestAllowed"
              >View Access</mat-label
            >
            <mat-label *ngIf="!data.isViewRequestAllowed"
              >Viewing Date passed</mat-label
            >
          </mat-checkbox>
          <mat-checkbox
            class="me-1"
            formControlName="isSubmitAccess"
            [disabled]="!data.isSubmitRequestAllowed"
          >
            <mat-label class="me-2" *ngIf="data.isSubmitRequestAllowed"
              >Submit Access</mat-label
            >
            <mat-label *ngIf="!data.isSubmitRequestAllowed"
              >Submitting Date passed</mat-label
            >
          </mat-checkbox>
          <!--<mat-checkbox class="me-1"
                        formControlName="isXrayDownloadAccess"></mat-checkbox><mat-label>X-Ray Download Access</mat-label>-->
        </div>
      </div>
      <div class="row mb-2" *ngIf="isDenied">
        <div class="col-2 align-self-center">
          <mat-label>Comments</mat-label>
        </div>
        <div class="col-10 align-self-center">
          <textarea
            class="form-control w-100"
            formControlName="comments"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="button-group">
        <button
          type="submit"
          class="btn btn-primary"
          *ngIf="IsShowSend()"
          [disabled]="!form.value.isSubmitAccess && !form.value.isViewAccess"
        >
          <span>Send</span>
        </button>
        <button type="submit" class="btn btn-primary" *ngIf="isDenied">
          <span>Reject</span>
        </button>
      </div>
    </div>
  </form>
</div>
